import { Box } from "@mui/material";
import {
  EnterpriseServiceListItemDto,
  EnterpriseServiceVariantUpdateListItemDto,
} from "Api/Api";
import { PriceColumnsRow } from "Components/Settings/Services/PriceColumns";
import { ServicesFormModel } from "Components/Settings/Services/ServicesForms";
import { BlCheckboxInput } from "Components/Shared/Inputs/Form/BlCheckboxInput";
import { PriceTaxType } from "Constants/PriceTaxType";
import { calculatePriceByPriceTaxTax } from "Hooks/useWithTax";
import { FieldPath, UseFormReturn } from "react-hook-form";

const MAX_PRICE_WITHOUT_TAX = 99999;

type Props = {
  serviceSettingServiceVariantID: number;
  formVariant: EnterpriseServiceVariantUpdateListItemDto;
  service: EnterpriseServiceListItemDto;
  form: UseFormReturn<ServicesFormModel>;
  onIsEnabledChange?: (isEnabled: boolean) => void;
};

export const ServiceVariant: React.FunctionComponent<Props> = props => {
  const {
    formVariant,
    service,
    form,
    serviceSettingServiceVariantID,
    onIsEnabledChange,
  } = props;
  const {
    control,
    setValue,
    getValues,
    trigger,
    watch,
    formState: { errors, isSubmitted },
  } = form;

  const variant = service.variants.find(
    x =>
      x.serviceSettingServiceVariantID ===
      formVariant.serviceSettingServiceVariantID,
  );

  const services = watch("services");

  var indexes = services
    ?.map((x, serviceIndex) => {
      if (x.serviceSettingID !== service.serviceSettingID) {
        return null;
      }
      var serviceVariantIndex =
        x.serviceSettingID === service.serviceSettingID &&
        x.variants.findIndex(
          y =>
            y.serviceSettingServiceVariantID === serviceSettingServiceVariantID,
        );
      return serviceVariantIndex === -1
        ? null
        : [serviceIndex, serviceVariantIndex as number];
    })
    .filter(x => !!x)[0];

  const [serviceIndex, serviceVariantIndex] = indexes!;

  const getFieldName = (
    fieldName: "isEnabled" | "priceWithoutTax" | "priceWithTax",
  ): FieldPath<ServicesFormModel> => {
    return `services.${serviceIndex}.variants.${serviceVariantIndex}.${fieldName}`;
  };

  const onPriceWithoutTaxChange = (taxRate: number) => {
    setValue(
      getFieldName("priceWithTax"),
      calculatePriceByPriceTaxTax(
        getValues(getFieldName("priceWithoutTax")) as number,
        taxRate,
        PriceTaxType.WithoutTax,
      ),
    );
  };

  const onPriceWithTaxChange = (taxRate: number) => {
    setValue(
      getFieldName("priceWithoutTax"),
      calculatePriceByPriceTaxTax(
        getValues(getFieldName("priceWithTax")) as number,
        taxRate,
        PriceTaxType.WithTax,
      ),
    );
  };

  return (
    <>
      <Box>
        <BlCheckboxInput
          control={control}
          errors={errors}
          name={getFieldName("isEnabled")}
          label={variant?.name}
          onChange={v => {
            onIsEnabledChange?.(v);
            isSubmitted && trigger(`services.${serviceIndex}.variants`);
          }}
        />
      </Box>

      {!!variant && formVariant.isEnabled ? (
        <PriceColumnsRow
          control={control}
          errors={errors}
          netFieldName={getFieldName("priceWithoutTax")}
          grossFieldName={getFieldName("priceWithTax")}
          taxRate={variant.taxRate}
          maxNet={MAX_PRICE_WITHOUT_TAX}
          onNetChange={() => onPriceWithoutTaxChange(variant.taxRate)}
          onGrossChange={() => onPriceWithTaxChange(variant.taxRate)}
        />
      ) : (
        <>
          <div />
          <div />
          <div />
        </>
      )}
    </>
  );
};
